import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import DefaultLayout from "../../layouts/DefaultLayout";
import { Button, Card, Col, Descriptions, Row, Switch } from "antd";

/**
 * Admin component.
 */
@inject("context")
@observer
class Admin extends Component {
	render() {
		const { settings } = this.props.context.applicationService;
		return (
			<DefaultLayout>
				<Row>
					<Col
						xs={24}
						sm={{ span: 20, offset: 2 }}
						lg={{ span: 12, offset: 6 }}
					>
						<Card title={<h1>Application settings</h1>}>
							<Descriptions bordered column={1}>
								<Descriptions.Item label="Session persistence">
									<Switch
										onChange={this.toggleSessionPersistence}
										checked={settings.sessionPersistence}
									/>
								</Descriptions.Item>
								<Descriptions.Item label="Send renewal reminders">
									<Button type="primary" onClick={this.sendRenewalReminders}>
										Send
									</Button>
								</Descriptions.Item>
							</Descriptions>
						</Card>
					</Col>
				</Row>
			</DefaultLayout>
		);
	}

	toggleSessionPersistence = () => {
		const service = this.props.context.applicationService;

		service.changeSetting(
			"sessionPersistence",
			!service.settings.sessionPersistence
		);
	};

	sendRenewalReminders = () => {
		this.props.context.applicationService.sendRenewalReminders();
	};
}

export default Admin;
